export const homeObjOne = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Freelance Software Engineering (for Businesses)',
  headline: 'Bring clean, scalable code to your projects',
  description:(
  <>
    I partner with companies on short- and mid-term freelance engineering needs. My focus is on writing maintainable code, improving architecture, and delivering production-ready solutions across the web stack.
    <br /><br />
    <strong>Technologies I work with:</strong>
    <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
      <li>C#, .NET Core</li>
      <li>Vue.js, React, Angular</li>
      <li>Web APIs, RESTful services</li>
      <li>HTML, CSS, JavaScript/TypeScript</li>
      <li>Azure, AWS, GitHub</li>
    </ul>
  </>
),
  buttonLabel: 'Get Started',
  linkTarget: "/counseling?type=freelance",
  imgStart: '',
  img: require('../../images/freelance-software-engineering.png'),
  alt: 'Engineering Work',
  start: ''
};


export const homeObjTwo = {
  primary: false,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Developer Coaching & Interview Prep (for programmers)',
  headline: 'Master data structures, algorithms, and core development concepts',
  description:(
  <>
    I offer personalized 1-on-1 coaching to help you succeed in technical interviews or strengthen your real-world development skills.
    <br /><br />
    <strong>Topics include:</strong>
    <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
      <li>Data structures & algorithms (with YouTube tutorials)</li>
      <li>Clean coding practices</li>
      <li>C#, .NET Core, Web APIs</li>
      <li>Frontend frameworks: Vue.js, React, Angular</li>
      <li>HTML, CSS, TypeScript</li>
      <li>System design fundamentals</li>
    </ul>
    <br />
    Sessions are tailored to your experience level and goals.
  </>
),

  buttonLabel: 'Book a Session',
  linkTarget: "/counseling?type=coaching",
  imgStart: 'start',
  img: require('../../images/developer-coaching.jpeg'),
  alt: 'Coaching',
  start: 'true'
};

export const homeObjThree = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Instant Setup',
  headline: 'Extremely quick onboarding process',
  description:
    "Once you've joined, our team of specialist will reach out to you and get you set up in minutes.",
  buttonLabel: 'Learn More',
  imgStart: '',
  img: require('../../images/svg-1.svg').default,
  alt: 'Vault',
  start: ''
};

export const homeObjFour = {
  primary: false,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Sarah Tash',
  headline:
    'I have masters in Software Engineering and 9 years of experience!',
  description:
    "Our team provide you the knowledge you need in order to get better jobs!",
  buttonLabel: 'View Requirements',
  imgStart: 'start',
  img: require('../../images/300b300.png'),
  alt: 'Vault',
  start: 'true'
};
